import {
  parseConversationList,
} from 'src/local-logic/tip-match/tim/conversation-list';
import {
  storeGetTimMsg,
  storeGetUnreadCount,
  storeGetRobotsUnreadCount,
} from './msg-helper';

const POOL_INTERVAL = 10 * 1000;
let getTimMsgTimer;
let getUnreadCountTimer;

const msgCenterStore = {
  namespaced: true,
  state: () => ({
    unreadMsgCount: 0,
    userunreadMsgCount: 0,
    conversationList: [],
    showRobotMsg: true, // 是否展示小助手消息，用户点击x后为false，新消息来后，恢复true
    eSportNewMsg: null, // 小助手新消息, null/Object
    unreadTeamMsgCount: 0, // 战队新消息数
    usedTimMixin: false,
  }),
  mutations: {
    setUnreadMsgCount(state, {
      count: unreadMsgCount = 0,
      // from,
    }) {
      state.unreadMsgCount = unreadMsgCount;
      // console.info('[state.setUnreadMsgCount]', `from:${from}`,
      // `count:${unreadMsgCount}`, `state.unreadMsgCount:${state.unreadMsgCount}`);
    },
    setMsgCountpolling(state, unreadMsgCount = 0) {
      // 优先使用 tim-mixin 中的
      if (!state.usedTimMixin) {
        state.userunreadMsgCount = Math.max(0, state.unreadMsgCount - unreadMsgCount);
      }
      // console.info('[state.setMsgCountpolling]', `count:${unreadMsgCount}`,
      //  `state.userunreadMsgCount:${state.userunreadMsgCount}`);
    },
    setMsgCount(state, unreadMsgCount = 0) {
      state.userunreadMsgCount =  unreadMsgCount;
      state.usedTimMixin = true;
      // console.info('[state.setMsgCount] mixin:', `count:${unreadMsgCount}`,
      //  `state.userunreadMsgCount:${state.userunreadMsgCount}`);
    },
    setConversationList(state, conversationList = []) {
      const list = parseConversationList(conversationList);
      state.conversationList = list;

      const val = list.filter(item => !!item.unreadCount).length;
      state.setUnreadMsgCount = val;
    },
    setShowRobotMsg(state, showRobotMsg) {
      state.showRobotMsg = showRobotMsg;
    },
    // latest and unread
    setESportRobotNewMsg(state, msg = {}) {
      state.eSportNewMsg = msg;
    },
    setTeamUnreadMsgCount(state, unreadMsgCount = 0) {
      state.unreadTeamMsgCount = unreadMsgCount;
    },
  },
  actions: {
    // 由于tim的rest API返回的isPeerRead始终为0，导致无法获取真正的未读消息
    getTimMsg(context, _uid) {
      storeGetTimMsg(context);
      clearInterval(getTimMsgTimer);
      getTimMsgTimer = setInterval(() => {
        storeGetTimMsg(context);
      }, POOL_INTERVAL);
    },
    getTimUnReadCount(context, uid) {
      storeGetUnreadCount(context, uid);
      storeGetRobotsUnreadCount(context);
      clearInterval(getUnreadCountTimer);

      getUnreadCountTimer = setInterval(() => {
        storeGetUnreadCount(context, uid);
        storeGetRobotsUnreadCount(context);
      }, POOL_INTERVAL);
    },
  },
  getters: {},
};

export default msgCenterStore;
